import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RouteGeometryManagement from './pages/route-geometry-management';
import AdminDashboard from './pages/admin-dashboard';
import SchedulesManagement from './pages/schedules-management';
import Home from './pages/home';
import RouteDetail from './pages/route-detail';
import RoutesManagement from './pages/routes-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Home />} />
        <Route path="/route-geometry-management" element={<RouteGeometryManagement />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/schedules-management" element={<SchedulesManagement />} />
        <Route path="/home" element={<Home />} />
        <Route path="/route-detail" element={<RouteDetail />} />
        <Route path="/routes-management" element={<RoutesManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
